import { render, staticRenderFns } from "./checkDialog.vue?vue&type=template&id=028cb340&scoped=true&"
import script from "./checkDialog.vue?vue&type=script&lang=js&"
export * from "./checkDialog.vue?vue&type=script&lang=js&"
import style0 from "./checkDialog.vue?vue&type=style&index=0&id=028cb340&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028cb340",
  null
  
)

export default component.exports